'use strict';


//Model name
angular.module('dash.map.AnnotationLayerEditor', [])
	.controller('AnnotationLayerEditorController', require('./AnnotationLayerEditorController'))
	.directive('annotationLayerEditor', require('./AnnotationLayerEditorDirective'));


// WEBPACK FOOTER //
// ./src/app/dash/map/annotationLayerEditor/index.js